const SKILLS = [
  {
    id: 0,
    name: 'JavaScript',

  },
  {
    id: 1,
    name: 'React',

  },
  {
    id: 2,
    name: 'HTML',

  },
  {
    id: 3,
    name: 'CSS',

  },
  {
    id: 4,
    name: 'SASS',

  },
  {
    id: 5,
    name: 'GIT',

  },
  {
    id: 6,
    name: 'Typescript',

  },
  {
    id: 7,
    name: 'Webpack',

  },
  {
    id: 8,
    name: 'NodeJS basics',

  },
  {
    id: 9,
    name: 'Jest',

  },
];

export { SKILLS }